import React, { FC } from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import useCommonStyles from 'styles/common';
import CenterImage from 'components/common/CenterImage';
import noticeTitleImg from 'assets/notice-title.svg';

import PillTitle from './PillTitle';

const useStyles = makeStyles((theme) => ({
	noticeSection: { 
		color: 'var(--color-tertiary)',
        marginTop: 53,
        textAlign: 'left',
	},
    noticeSectionTitle: {
        maxWidth: 192,
        [theme.breakpoints.down('xs')]: {
			maxWidth: 160,
		}
    },
    noticeContainer: {
        maxWidth: 1100,
        alignItems: 'start',

        '& ul': {
            margin: '16px 0',
            '& li': {
                fontSize: 20 // for set bullet size
            }
        },
        [theme.breakpoints.down('xs')]: {
            padding: '0 38px',

            '& ul': {
                paddingLeft: 23,
                '& li': {
                }
            },
        }
    }
}));

interface Props {
    titleRef: React.RefObject<HTMLDivElement>;
}

const NoticeSection: FC<Props> = ({titleRef}) => {
	const classes = useStyles();
	const common = useCommonStyles();

	return (<div className={ cx(common.columnCenter, common.fullWidth, classes.noticeSection) }>
		<CenterImage divRef={titleRef} src={noticeTitleImg} alt='notice-title' className={classes.noticeSectionTitle}/>

        <div className={cx(common.columnCenter, common.fullWidth, classes.noticeContainer )}>
            <Typography variant="body2" style={{ marginTop: 36 }}
            >{`凡參加者，即視為已充分瞭解本注意事項中各項條款，且願意完全遵守及同意本活動之各項規定辦法：`}</Typography>
            
            <PillTitle style={{ marginTop: 16 }}>投票注意事項：</PillTitle>
            <ul>
                <li><Typography variant='body2'>{`每人每日限投一票，可以每日進行投票，中獎機會越高。`}</Typography></li>
                <li><Typography variant='body2'>{`投票且參加抽獎者所提供之個人資料僅使用於票數統計及抽獎活動用途。`}</Typography></li>
                <li><Typography variant='body2'>{`投票期間，禁止任何不正當或利用電腦程式灌票，若經查出惡意灌票行為，或任何影響本活動進行之行為，將取消本獎項參賽資格。`}</Typography></li>
                <li><Typography variant='body2'>{`參加者若以惡意之電腦程式或其他明顯違反活動公平性之方式(利用電腦、網路之漏洞或不正當之行為)，意圖混淆或影響活動結果者，一經主辦單位察覺得立即取消參加者之參加與中獎資格，並得返還獎品。參加者對於因違反相關規定所產生之一切法律責任，需自行負擔。`}</Typography></li>
                <li><Typography variant='body2'>{`主辦單位保留所有修改活動與獎項細節的權利，無需事前通知，並有權對本活動所有事宜作出解釋或裁決。如本活動因不可抗力之特殊原因無法執行時，主辦單位有權決定取消、終止、修改或暫停本活動。`}</Typography></li>
            </ul>
            <PillTitle>抽獎注意事項：</PillTitle>
            <ul>
                <li><Typography variant='body2'>{`每日投票次數越多，中獎機會越高，惟每人限得一個獎項，以第一個抽中獎品為主。`}</Typography></li>
                <li><Typography variant='body2'>{`活動採隨機方式抽出參與者，主辦單位就本活動參加者之資格，保有審查之權利。`}</Typography></li>
                <li><Typography variant='body2'>{`參加抽獎者於參加本活動之同時，即同意接受本活動所有內容及細則之規範，如有違反本活動注意事項之行為，得取消其中獎資格，並對於任何破壞本活動之行為保留相關權利。`}</Typography></li>
                <li><Typography variant='body2'>{`本活動如有任何不可歸責於主辦單位之事由（電腦、網路等），而使中獎者所填寫之資料有遺失、錯誤、無法辨識或毀損，導致資料無效之情況，主辦單位不負任何法律責任，參加者或中獎者不得異議。`}</Typography></li>
                <li><Typography variant='body2'>{`參加抽獎者保證參加之帳號及所有提出之資料均為真實且正確，如有不實或不正確，將被取消得獎資格。如因此損害主辦單位或其他任何第三者，參加者需負一切相關責任。`}</Typography></li>
            </ul>

            <PillTitle>兌獎注意事項：</PillTitle>
            <ul>
                <li><Typography variant='body2'>{`本活動僅限在台澎金地區進行，活動獎項之寄送地址亦僅限台澎金地區。`}</Typography></li>
                <li><Typography variant='body2'>{`主辦單位公布得獎者後，中獎者需填妥兌獎通知函，並以掛號方式寄回兌獎領據，經主辦單位核對中獎資訊無誤後，才得以進行兌獎作業。`}</Typography></li>
                <li><Typography variant='body2'>{`參加者同意填寫或提出之資料均為真實，且未冒用或盜用任何第三人之資料。依規定或資料有誤者，則取消得獎資格。`}</Typography></li>
                <li><Typography variant='body2'>{`得獎者未於指定之期限前回覆並繳交相關資料，或如未提供正確資訊或未詳細填寫個人基本資料，導致活動中獎時無法通知、逾期及資料缺漏者，或無法正確投遞至寄送地址等影響中獎相關事宜或作業程序，視同放棄得獎資格。資料填寫錯誤、不完整，致獎品無法送達，則視同放棄，不另補發。主辦單位將不再另進行候補中獎者抽選。`}</Typography></li>
                <li><Typography variant='body2'>{`所有中獎資格之查驗，依本活動辦法及主辦單位之實際審核結果為準，並為唯一之依據。`}</Typography></li>
                <li><Typography variant='body2'>{`所有得獎者之聯絡資料，僅用於主辦單位通知及活動領獎確認用，不會另作其他用途。`}</Typography></li>
                <li><Typography variant='body2'>{`獎品金額超過新台幣20,001元以上，依國稅局規定得獎者需依稅法先行自付10%機會中獎稅，由主辦單位或協辦單位或執行單位代扣繳，始得領取活動獎品，不願繳交稅金者視同放棄得獎權利。非中華民國境內居住之個人(即在中華民國境內居未達183天之本國人及外國人)不論中獎所得之金額，須就中獎所得扣繳20%機會中獎稅。主辦單位年底將開立各類所得稅扣繳憑單給中獎者，獎項價值以主辦單位實際購買贈品之統一發票或收據金額為主。(有關「中獎獎金之扣繳稅款」以財政部發佈之條款為準)。`}</Typography></li>
                <li><Typography variant='body2'>{`中獎者不得要求更改獎項或兌換現金，獎項均以實物為準，恕不得選款式、型號、挑色，亦不得將中獎資格轉讓其他人。`}</Typography></li>
                <li><Typography variant='body2'>{`違反前述規定之中獎人，主辦單位得取消其中獎項資格。若遇得獎贈品已寄出，則需將得獎贈品寄還活動小組，得獎贈品必須寄還新品。`}</Typography></li>
                <li><Typography variant='body2'>{`贈品在郵寄過程中，所造成的毀壞、遲遞、錯誤或遺失，主辦單位恕不負責。`}</Typography></li>
                <li><Typography variant='body2'>{`關於獎項之使用細節，或發生產品瑕疵及相關保固責任，均由該贈品廠商維修與保固，中獎者應逕向獎品製造或銷售公司詢問，台灣好侍食品股份有限公司及其執行單位概不負責。`}</Typography></li>
            </ul>

            <PillTitle>機票兌獎憑證注意事項： </PillTitle>

            <Typography
                variant="body2"
                style={{ whiteSpace: 'pre-line', margin: '16px 0' }}
            >
                {`1.日本單人來回機票(票券價值NT$30,000元)，以「兌換憑證」方式提供。中獎人須自行聯繫本次配合之指定旅行社辦理兑獎。
                聯繫方式將於兌獎憑證中提供。

                2.本兌換憑證係針對「好侍紅白洋食發票登錄」抽獎活動所設計，限中獎者本人始得兌獎憑證內容，不得轉讓於他人使用。

                3.機票地點將依「好侍紅白洋食對決」投票活動最終投票結果而定，蕃茄燴飯獲勝則地點為日本九州熊本來回機票；
                北海道白醬獲勝地點為日本北海道來回機票。中獎人不得要求兌換其他地點之機票。

                4.獎項限一次兌換完畢，實際兌換機票之價值如低於本憑證價值，恕不退差價：如高於本憑證價值時，需另行補票差價。
                另不得兌換現金，使用後無法更改或取消。

                5.中獎者應於2025年8月1日至2026年7月31日之前出發
                (機票不適用特定日期2025/12/27-2025/12/31、2026/01/01-2023/01/04、2026/02/11-2026/02/28、2026/04/01-2026/04/05、2026/05/26-2026/05/31，其餘日期皆可使用)。 
                逾期無效，視同放棄獎項，且不再後補。
                各班機供活動使用之機位數量有限，建議及早預訂。

                6.機票開立後，不可更改行程(來回日期/班機/航線)，不可背書轉讓其它航空公司或他人使用。機票一經使用即無法退票。

                7.航空公司會隨時調整票，以指定旅行社訂位報價為主。

                8.獎項機票包含：
                (1)日本來回機票乙張。

                9.獎項機票不包含：
                (1)機票拖運行李超重或超件費。
                (2)訂位開票、選位手續費。
                (3)機場稅及燃油附加費、雜支等。
                (4)任何保險、簽證費用。

                10.其他未盡事宜依指定旅行社、搭乘之航空公司規定為準。`}
            </Typography>

            <PillTitle>活動洽詢</PillTitle>
            <Typography variant="body2" style={{ marginTop: 16 }}
            >{`好侍紅白洋食對決活動小組housecurryevents@gmail.com`}</Typography>
            
        </div>
	</div>);
};

export default NoticeSection;
